module.exports = __webpack_public_path__ + "teqbahn-assets/media/Vidya.eb430621.jpg";